import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumberDisplay',
})
export class PhoneNumberDisplayPipe implements PipeTransform {
  transform(phoneNumber: string): string {
    if (Number.parseInt(phoneNumber).toString().length === phoneNumber.length) {
      return `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(
        3,
        6
      )}-${phoneNumber.substring(6, 10)}`;
    }
    return phoneNumber ? phoneNumber : '';
  }
}
